<template>

  <v-autocomplete v-model="categoryGender"
                  label="Gender"
                  :placeholder="placeholder"
                  :items="categories"
                  item-text="gender"
                  item-value="gender"
                  :clearable="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"></v-autocomplete>

</template>

<script>

export default {
  name: 'CategoryGenderSelector',
  props: ['federationID', 'currentCategoryGender', 'disabledText'],
  data () {
    return {
      loading: false,
      categories: [],
      categoryGender: ''
    }
  },
  mounted () {
    if (this.federationID) {
      this.loadCategoryGenders()
    }

    if (this.currentCategoryGender) {
      this.categoryGender = this.currentCategoryGender
    }
  },
  methods: {
    loadCategoryGenders () {
      let gender = ''
      if (!this.currentCategoryGender) {
        this.$emit('categoryGenderSelected', '')
      } else {
        gender = this.currentCategoryGender
      }

      if (this.federationID) {
        this.loading = true
        this.$store.dispatch('getFederationCategories', this.federationID)
          .then(resp => {
            this.categories = resp
            if (gender) {
              this.categoryGender = gender
            }
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            alert('Error loading categories')
          })
      } else {
        this.clear()
      }
    },
    clear () {
      this.categoryGender = ''
      this.categories = []
    }
  },
  computed: {
    isDisabled () {
      return this.categories.length === 0
    },
    placeholder () {
      return this.isDisabled ? this.disabledText || 'Please select a club first' : 'Age'
    }
  },
  watch: {
    'federationID' () {
      this.clear()
      this.loadCategoryGenders()
    },
    'categoryGender' () {
      this.$emit('categoryGenderSelected', this.categoryGender || '')
    },
    'currentCategoryGender' () {
      if (this.currentCategoryGender) {
        this.categoryGender = this.currentCategoryGender
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/CategoryGenderSelector.vue